<template>
  <div>
    <Banners page="home" />
    <div>
      <Breadcrumb> </Breadcrumb>
    </div>
    <div class="categories">
      <div class="category" v-if="hasTickets">
        <router-link class="ticketLink" :to="{ name: 'tickets', params: { lang: language } }">
          <div class="svgWrapper"><TicketIcon /></div>
          <h1>{{ getNavName('NAV_TICKETS') }}</h1>
        </router-link>
      </div>
      <div class="category" v-if="hasDayTickets">
        <router-link class="dayTicketLink" :to="{ name: 'dayTickets', params: { lang: language } }">
          <div class="svgWrapper"><TicketIcon /></div>
          <h1>{{ getNavName('NAV_DAY_TICKETS') }}</h1>
        </router-link>
      </div>
      <div class="category" v-if="hasGuidedTours">
        <router-link
          class="guidedTourLink"
          :to="{ name: 'guidedTours', params: { lang: language } }"
        >
          <div class="svgWrapper"><GuidedTourIcon /></div>
          <h1>{{ getNavName('NAV_GUIDED_TOURS') }}</h1>
        </router-link>
      </div>
      <div class="category" v-if="hasMerchandise">
        <router-link
          class="merchandiseLink"
          :to="{ name: 'merchandise', params: { lang: language } }"
        >
          <div class="svgWrapper"><MerchandiseIcon /></div>
          <h1>{{ getNavName('NAV_MERCHANDISE') }}</h1>
        </router-link>
      </div>
      <div class="category" v-if="hasMemCard">
        <router-link class="annualPassLink" :to="{ name: 'passes', params: { lang: language } }">
          <div class="svgWrapper"><AnnualPassIcon /></div>
          <h1>{{ getNavName('NAV_MEMCARD') }}</h1>
        </router-link>
      </div>
      <div class="category" v-if="hasVouchers">
        <router-link class="voucherLink" :to="{ name: 'voucherList', params: { lang: language } }">
          <div class="svgWrapper"><VoucherIcon /></div>
          <h1>{{ getNavName('NAV_VOUCHERS') }}</h1>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import GuidedTourIcon from './GuidedTourIcon.vue';
import TicketIcon from './TicketIcon.vue';
import MerchandiseIcon from './MerchandiseIcon.vue';
import VoucherIcon from './VoucherIcon.vue';
import AnnualPassIcon from './AnnualPassIcon.vue';
import Banners from '../Banners/Banners.vue';
import Breadcrumb from '../Breadcrumbs.vue';
import { setPageTitle } from '../../lib/pageTitle';
import { useSeoMeta } from '@unhead/vue';

export default {
  name: 'ProductCategoriesBig',
  components: {
    Banners,
    Breadcrumb,
    VoucherIcon,
    TicketIcon,
    MerchandiseIcon,
    GuidedTourIcon,
    AnnualPassIcon,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
      hasMerchandise: (state) => state.app.hasMerchandise,
      hasTickets: (state) => state.app.hasTickets,
      hasDayTickets: (state) => state.app.hasDayTickets,
      hasGuidedTours: (state) => state.app.hasGuidedTours,
      hasVouchers: (state) => state.app.hasVouchers,
      hasMemCard: (state) => state.app.hasMemCard,
      navTranslations: (state) => state.app.navTranslations,
      meta: (state) => state.meta.data,
      publicURL: (state) => state.app.API_PUBLIC_URL,
    }),
  },
  methods: {
    getNavName(type) {
      if (typeof this.navTranslations !== 'undefined') {
        if (typeof this.navTranslations[type] !== 'undefined') {
          if (
            typeof this.navTranslations[type][this.language] !== 'undefined' &&
            this.navTranslations[type][this.language] !== ''
          ) {
            return this.navTranslations[type][this.language];
          }
        }
      }
      return this.$t(type);
    },
    setMeta() {
      let title = '';
      let description = '';
      let keywords = '';
      let image = '';
      if (typeof this.meta !== 'undefined') {
        if (typeof this.meta.home !== 'undefined') {
          description = this.meta.home.description;
          keywords = this.meta.home.keywords;
          if (this.meta.home.image) {
            image = `${this.publicURL}1200/${this.meta.home.image}`;
          }
          title = this.meta.home.title;
        }

        useSeoMeta({
          title: setPageTitle(title),
          ogTitle: setPageTitle(title),
          description,
          keywords,
          ogDescription: description,
          ogImage: image,
        });
      }
    },
  },
  watch: {
    meta() {
      this.setMeta();
    },
  },
  mounted() {
    this.setMeta();
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/grid';
.categories {
  display: flex;
  flex-wrap: wrap;
  gap: $sp * 4;
  width: calc(100% - 30px);
  text-align: center;
  padding-top: 5 * $sp;
  padding-bottom: 5 * $sp;
  background-color: $block-color;
  justify-content: space-around;
  padding-left: 10%;
  padding-right: 10%;
}
.category {
  flex: 1 1 0px;
  width: 0;
  min-width: 10em;
  a {
    display: block;
  }
}
@media screen and (max-width: $screen-md) {
  h1 {
    font-size: $font-size-h4;
    line-height: 1.5;
  }
}
@media screen and (max-width: $screen-xs) {
  h1 {
    font-size: $font-size-h5;
  }
}

.svgWrapper {
  height: 100%;
  max-width: 200px;
  margin-left: auto;
  margin-right: auto;
}
</style>

<style lang="scss">
.categories .svgWrapper svg {
  width: auto !important;
  max-width: 100%;
  height: 100% !important;
}
</style>
